@if (loading) {
<img class="logo-loading" [src]="loaderSrc" alt="loading" />
} @else {
<app-legal-terms [isAcceptance]="true" [sendLbl]="labels().LEGAL_TERMS_ACCEPTANCE_COMPONENT_SEND_BTN" />
}